import fetch from "auth/FetchInterceptor";

export const ReportService = {};

ReportService.get = async (data) => {
  let apiUrl = "/v1/report/" + data.type + "?";
  if (data.outlet) apiUrl += "&outlet=" + data.outlet;
  if (data.district) apiUrl += "&district=" + data.district;
  if (data.date) apiUrl += "&date=" + data.date;
  if (data.date_from) apiUrl += "&date_from=" + data.date_from;
  if (data.date_to) apiUrl += "&date_to=" + data.date_to;
  if (data.type_filter) apiUrl += "&type=" + data.type_filter;
  if (data.status) apiUrl += "&status=" + data.status;
  if (data.inv) apiUrl += "&inv=" + data.inv;
  return fetch({
    url: apiUrl,
    method: "get",
    responseType: "blob",
  });
};

export default ReportService;
